var animatedFaqs;
var faqHeight;
var activeQuestion;
var activeHeight;
var initLoad = false;

function setFaqHeight() {
faqHeight = 0;

$('.question-contain:visible').each(function() {
    faqHeight = faqHeight + ($(this).height() / 1.3);
});

document.documentElement.style.setProperty('--faq-container-height',  `${faqHeight}px`);



if(initLoad == false) {
$('.faq-inner').addClass('loaded');
initLoad = true;
}


}

setFaqHeight();

$('.question-item').click(function() {

    var questionHeight = $(this).find('.question-answer').data('height');
    activeHeight = $('.active-question').not(this).find('.question-answer').data('height');

    if(activeHeight == null || activeHeight == undefined || activeHeight == NaN) {
        activeHeight = 0;
    }

    if($(this).hasClass('active-question')) {
        faqHeight = faqHeight - questionHeight;
    }

    else {
        faqHeight = faqHeight + questionHeight - activeHeight;
    }

    document.documentElement.style.setProperty('--faq-container-height',  `${faqHeight}px`);

});

function setfaqWidth() {
    var el = document.querySelector(".animate-faq-heading"); 
    var initialfaqs = document.querySelector(".initial-headings"); 
    var faqwidth = $(el).width();
    var initialfaqwidth = $(initialfaqs).width();
    $(el).attr('data-width', `${faqwidth}`).attr('data-initial-width', `${initialfaqwidth}`);
    animateFaq(el,initialfaqwidth)
}

$(function () {
    setfaqWidth();
});

window.addEventListener("resize", setfaqWidth);

function animateFaq(el,initialwidth) {

speed = $('.desire-item-header').length * 5000;

animatedFaqs = el.animate([
  { transform: 'translateX(0)' }, 
  { transform: `translateX(-${initialwidth/2}px)` }
], {
  duration: speed,
  iterations: 999999
}) 
}

$('#faqChange').change(function() {
    filterChange(this, 'change');
});

$('.faq-filter-btn').click(function() {
    filterChange(this, 'click');
});

function filterChange(e,method) {
    if(method == 'click') {
        var newSelection = $(e).data('category');
    }
    else {
        var newSelection = $(e).find(':selected').data('category')
    }

    if($(document).scrollTop() > 10) {
        window.scrollTo(0, 10);
    }
    

    $('.faq-inner').addClass('faq-change');
    $('.faq-filter-btn').removeClass('active-filter');
    $(`[data-category="${newSelection}"]`).addClass('active-filter');
    $(`#faqChange [data-category="${newSelection}"]`).attr('selected', 'selected');

    setTimeout(() => {
        $('.question-item').removeClass('active-question');
        $('.active-heading-item h2').html(newSelection);
        if(newSelection != 'all faqs') {
        $(`.question-contain`).hide();
        $(`[data-faq-category="${newSelection}"]`).show();    
        }
        else {
            $(`.question-contain`).show();
        }
        animatedFaqs.cancel();
        setfaqWidth();
        setFaqHeight();
        $('.faq-inner').removeClass('faq-change');
      }, "350");
}